import {useMemo} from 'react';
import type {OverviewTask, TaskTypeAll} from 'services/tasks/types';
import {searchTasks, toggleTaskTypes} from '../functions';

export const useSearchedTasks = (
  allTasks: OverviewTask[] | undefined,
  taskType: TaskTypeAll | undefined,
  searchText: string | undefined,
): OverviewTask[] => {
  const filteredTasks = useMemo(() => {
    return toggleTaskTypes(allTasks || [], taskType);
  }, [allTasks, taskType]);

  return useMemo(() => {
    return searchText ? searchTasks(filteredTasks, searchText) : filteredTasks;
  }, [filteredTasks, searchText]);
};
